import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/styles/index.less";
import * as echarts from "echarts";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  CanvasRenderer,
] as any);

const app = createApp(App);
app.config.globalProperties.$Echarts = echarts;
app.use(ElementPlus).use(store).use(router).mount("#app");
